import { CustomError } from './custom-error';
import { CodeError } from '../constant/text.constant';

export class UserAuthenticationError extends CustomError {
  private static readonly CODE = CodeError.USER_AUTHENTICATION_FAILED;

  constructor() {
    super(UserAuthenticationError.CODE);
  }
}
